import React from "react";
import * as ReactGA from "react-ga";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { config } from "config";

export class GoogleAnalyticsProvider extends React.Component<
  React.PropsWithChildren<RouteComponentProps<any>>
> {
  public render() {
    return this.props.children;
  }

  public componentDidMount() {
    this.initGA();
  }

  private initGA = () => {
    ReactGA.initialize(
      config.googleAnalytics.trackingCode,
      config.googleAnalytics
    );
    this.trackPageView(this.props.location.pathname);

    this.props.history.listen((location) =>
      this.trackPageView(location.pathname)
    );
  };

  private trackPageView = (pathname: string) => {
    ReactGA.pageview(
      pathname,
      [config.googleAnalytics.gaOptions.name],
      "Spotlight - Photo Tool"
    );
  };
}

export default withRouter(GoogleAnalyticsProvider);
